export default __webpack_public_path__ + "static/media/bread-loaf.ca31b8c6.jpg";